import React, { useState } from "react";
import PropTypes from "prop-types";
import loadable from "@loadable/component";
import useStyles from "@hooks/useStyles";
import { compose } from "recompose";
import withStyles from "@framework/src/libs/withStyles";
import { styles } from "./.config";

//import Chip from "@components/Global/Custom/Chip";
import Chip from "@material-ui/core/Chip";
import CheckIcon from "@material-ui/icons/Check";
import AddIcon from "@material-ui/icons/Add";
import { Avatar, Paper, IconButton, Box } from "@material-ui/core";
import ServiceAdd from "./dialogs/ServiceAdd";
import ClassAdd from "./dialogs/ClassAdd";

import VideocamOutlinedIcon from "@material-ui/icons/VideocamOutlined";

import Zoom from "@material-ui/core/Zoom";
import Tooltip from "@material-ui/core/Tooltip";
import MembershipAdd from "./dialogs/MembershipAdd";

const BookingFunnelItems = compose(
	withStyles(styles)
	// withConstants(constants)
)(({ items, selectedItems, toggleItemSelection }) => {
	// const BookingFunnelItems = ({ items, selectedItems, toggleItemSelection }) => {
	const classes = useStyles("BookingFunnel");

	//const [selectedItems, setSelectedItems] = useState([]);

	// Pro global settings

	const categories = [{ name: "HVAC" }, { name: "Yoga" }, { name: "Dance" }];

	const showImage = true;

	//

	const [dialogType, setDialogType] = useState(null);

	// Function to open the dialog with the correct type
	const handleOpenDialog = (type) => {
		setDialogType(type);
	};

	// Function to close the dialog
	const handleCloseDialog = () => {
		setDialogType(null);
	};

	return (
		<>
			{dialogType === "service" && (
				<ServiceAdd open={true} onClose={handleCloseDialog} />
			)}
			{dialogType === "class" && (
				<ClassAdd open={true} onClose={handleCloseDialog} />
			)}
			{dialogType === "membership" && (
				<MembershipAdd open={true} onClose={handleCloseDialog} />
			)}

			{categories.map((category) => (
				<div className={classes.categoryBox} key={category.name}>
					<div className={classes.category}>{category.name}</div>
					{items
						.filter(
							(item) =>
								item.category.toLowerCase() === category.name.toLowerCase()
						)
						.map((item, index) => {
							const isSelected = selectedItems.includes(item.id);

							return (
								<div
									key={item.id}
									className={classes.buttonBase}
									onClick={() => {
										toggleItemSelection(item.id);
										handleOpenDialog(item.type);
									}}
								>
									<Paper
										variant="outlined"
										className={
											isSelected ? classes.selectedPaper : classes.paper
										}
									>
										<div className={classes.boxWrapper}>
											<div className={classes.boxGap}>
												<div className={classes.boxFlex100}>
													{showImage && (
														<div className={classes.itemAvatarPadding}>
															<Avatar
																variant="rounded"
																className={classes.itemAvatar}
																imgProps={{
																	loading: "lazy",
																	decoding: "async",
																}}
																alt=""
																src={item.imageUrl}
															/>
														</div>
													)}
													<div className={classes.content}>
														<div className={classes.itemTitle}>
															{item.title}
														</div>
														{item.type === "service" ? (
															<div className={classes.itemDetails}>
																{item.time}
															</div>
														) : item.type === "membership" ? (
															<>
																<div className={classes.itemDetails}>
																	{item.details}
																</div>
															</>
														) : (
															<>
																<div className={classes.itemDetails}>
																	{item.dayTime}{" "}
																	<span className={classes.itemDetailsNoBreak}>
																		({item.schedule})
																	</span>
																</div>
															</>
														)}
														{item.ageRange && (
															<div className={classes.itemDetails}>
																{item.ageRange}
															</div>
														)}
														{item.description && item.type === "service" && (
															<div
																className={`${classes.itemDetails} ${classes.itemTruncate}`}
															>
																{item.description}
															</div>
														)}
														<div className={classes.itemFeatures}>
															{item.features &&
																item.features.map((feature, featureIndex) => (
																	<Chip
																		key={featureIndex}
																		//variant={"outlined"}
																		size="small"
																		label={feature}
																		clickable
																		className={classes.chip}
																		// Optionally, add logic for color or icon based on the feature
																	/>
																))}
														</div>
														<div className={classes.itemPrice}>
															{item.price === "0" ? "Free" : item.price}
														</div>
													</div>
												</div>

												{item.spotsLeft < 3 ? (
													<>
														<div className={classes.rightInfoSpots}>
															<div>
																<div className={classes.spotsLeft}>
																	{parseInt(item.spotsLeft) === 1
																		? "1 spot left!"
																		: `${item.spotsLeft} spots left!`}
																</div>
																&nbsp;
															</div>
															<div className={classes.flex}>
																<IconButton
																	size="small"
																	className={
																		isSelected
																			? classes.iconButtonSelected
																			: classes.iconButton
																	}
																>
																	{isSelected ? <CheckIcon /> : <AddIcon />}
																</IconButton>
															</div>
															<div>&nbsp;</div>
														</div>
													</>
												) : (
													<>
														<div className={classes.rightInfo}>
															<IconButton
																size="small"
																className={
																	isSelected
																		? classes.iconButtonSelected
																		: classes.iconButton
																}
															>
																{isSelected ? <CheckIcon /> : <AddIcon />}
															</IconButton>
														</div>
													</>
												)}
											</div>
										</div>
									</Paper>
								</div>
							);
						})}
				</div>
			))}
		</>
	);
});

export default BookingFunnelItems;
